const STEPS = [
  {
    icon: "ri-shield-keyhole-line",
    title: "全程匿名",
    desc: "不要求手机号、不强制注册。你可以只留一个代号，就能把一手材料递进来。",
  },
  {
    icon: "ri-file-search-line",
    title: "人工复核",
    desc: "编辑团队逐条核验时间线、主体与证据链，能过审的瓜才会上榜见光。",
  },
  {
    icon: "ri-user-voice-line",
    title: "脱敏见光",
    desc: "发布前对可指向你身份的信息做脱敏处理，保护隐私，同时保留吃瓜证据。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "合作递料",
    desc: "想长期合作、批量递内幕，可走专项合作入口，按匿名规则对接，减少顾虑。",
  },
];

const RULES = [
  "请确保线索真实、有时间线可循，越具体越容易被优先核验。",
  "投递前隐去与个人身份直接相关的信息，避免误伤与反查。",
  "截图、录音、单据等证据越完整，上榜与跟进的可能性越高。",
  "严禁编造、诽谤与无来源复制转发，涉及违法线索我们会依法移交。",
];

export default function Steps() {
  return (
    <section id="steps" className="relative py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-12">
          <div>
            <span className="inline-flex items-center gap-1.5 text-secondary-600 text-xs font-medium tracking-wide mb-3">
              <i className="ri-focus-3-line"></i> 投稿规则
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-extrabold text-foreground-950">
              匿名通道怎么走，说清楚
            </h2>
          </div>
          <a
            href="#submit"
            className="hidden md:inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            查看投递合作入口 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {STEPS.map((s, i) => (
            <div
              key={s.title}
              className="relative rounded-2xl bg-background-100 border border-background-200 p-6 md:p-7 hover:-translate-y-1 transition-transform"
            >
              <span className="absolute top-5 right-6 font-heading text-4xl font-black text-background-300 select-none">
                0{i + 1}
              </span>
              <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-600 text-xl mb-5">
                <i className={s.icon}></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">{s.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 md:mt-8 rounded-2xl border border-secondary-200 bg-secondary-50 p-5 md:p-6 flex flex-col gap-3">
          <div className="flex items-center gap-2 text-secondary-800 text-sm font-semibold">
            <i className="ri-megaphone-line text-lg"></i> 投递前请记牢这几条匿名规则
          </div>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2.5">
            {RULES.map((r) => (
              <li key={r} className="flex items-start gap-2 text-sm text-foreground-700 leading-relaxed">
                <i className="ri-checkbox-circle-line text-secondary-500 mt-0.5"></i>
                <span>{r}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}